var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80545 3.19966L11.3005 4.69403M10.7669 1.88318L6.72424 5.92581C6.51536 6.1344 6.3729 6.40015 6.31482 6.68958L5.94141 8.55877L7.8106 8.18465C8.10002 8.12677 8.36543 7.98489 8.57437 7.77594L12.617 3.73331C12.7385 3.61183 12.8349 3.46761 12.9006 3.30889C12.9663 3.15016 13.0002 2.98005 13.0002 2.80824C13.0002 2.63644 12.9663 2.46632 12.9006 2.3076C12.8349 2.14888 12.7385 2.00466 12.617 1.88318C12.4955 1.76169 12.3513 1.66533 12.1926 1.59958C12.0339 1.53384 11.8637 1.5 11.6919 1.5C11.5201 1.5 11.35 1.53384 11.1913 1.59958C11.0326 1.66533 10.8883 1.76169 10.7669 1.88318Z",
    stroke: "#313131",
    strokeWidth: 1.41178,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5883 9.97052V12.0882C11.5883 12.4626 11.4396 12.8217 11.1748 13.0865C10.9101 13.3512 10.551 13.5 10.1766 13.5H2.41178C2.03735 13.5 1.67826 13.3512 1.4135 13.0865C1.14874 12.8217 1 12.4626 1 12.0882V4.3234C1 3.94897 1.14874 3.58988 1.4135 3.32512C1.67826 3.06036 2.03735 2.91162 2.41178 2.91162H4.52945",
    stroke: "#313131",
    strokeWidth: 1.41178,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.9be960e71fe6072ae232011070583350.svg";
export { ForwardRef as ReactComponent };